import {
  Box,
  Container,
  Stack,
  Text,
  useColorModeValue,
} from "@chakra-ui/react"
import { SocialButton } from "./social-btn"
import { FiGitlab } from "react-icons/fi"
import { FaGithub, FaLinkedin } from "react-icons/fa"

export const FooterComponent = () => {
  return (
    <Box
      bg={useColorModeValue("gray.50", "gray.900")}
      color={useColorModeValue("gray.700", "gray.200")}
    >
      <Container
        as={Stack}
        maxW={"6xl"}
        py={4}
        direction={{ base: "column", md: "row" }}
        spacing={4}
        justify={{ base: "center", md: "space-between" }}
        align={{ base: "center", md: "center" }}
      >
        <Text>© {new Date().getFullYear()} DiDevs. All rights reserved</Text>
        <Stack direction={"row"} spacing={6}>
          <SocialButton
            label={"Linkedin"}
            href={"https://www.linkedin.com/in/diogenes-morais-244112121/"}
          >
            <FaLinkedin />
          </SocialButton>

          <SocialButton label={"Gitlab"} href={"https://gitlab.com/diornister"}>
            <FiGitlab />
          </SocialButton>

          <SocialButton label={"Github"} href={"https://github.com/diornister"}>
            <FaGithub />
          </SocialButton>
        </Stack>
      </Container>
    </Box>
  )
}
